<template lang="pug">
.CrisisEchartsChart
  #CrisisEchartsChart(style="width: 100%; height: 100%")
</template>

<script>
import echarts from 'echarts'
export default {
  props: {
    link: Array,
    right: {
      type: Number,
      default: 200,
      required: false
    },
    checkedName: {
      type: String,
      required: false
    }
  },
  data () {
    return {}
  },
  watch: {
    link: {
      handler (value) {
        if (value.length > 0) {
          // 按照时间排序
          const chartList = [...value].sort((a, b) => {
            return a[2] - b[2]
          })
          this.$nextTick(() => {
            this.initCharts(chartList)
          })
        }
      },
      immediate: true
    },
    checkedName () {
      if (this.checkedName && this.link.length) {
        this.initCharts(this.link)
      }
    }
  },
  methods: {
    initCharts (chartList) {
      let chart = echarts.init(document.getElementById('CrisisEchartsChart'))

      let data = this.getData(chartList)
      let links = this.getLinks(chartList)

      // console.log('data:', data)
      // console.log('links:', links)
      const option = {
        animation: false,
        series: [
          {
            type: 'sankey',
            // emphasis: {
            //   focus: 'adjacency'
            // },
            layoutIterations: 0, // 严格按照自己的顺序
            left: 0,
            top: 1,
            right: this.right,
            bottom: 0,
            data: data,
            links: links,
            draggable: false,
            lineStyle: {
              color: 'source',
              curveness: 0.5
            },
            // itemStyle: {
            //   color: '#1f77b4',
            //   borderColor: '#1f77b4'
            // },
            label: {
              // color: 'rgba(0,0,0,0.7)',
              // fontFamily: 'Arial',
              // fontSize: 10,
              width: 20
            }
          }
        ]
        // tooltip: {
        //   trigger: 'item',
        //   formatter: (params) => {
        //     console.log('params111:', params)
        //     return 'sss'
        //   }
        // }
      }
      // console.log('option:', option)
      chart.setOption(data.length ? option : {})
    },
    getData (list) {
      let datas = []
      // 1.变成echarts的数据格式
      list.forEach(t => {
        // 大标签
        const leftLabel = t[0]
        datas.push({
          name: leftLabel,
          isBig: true, // 是否是左侧大标签
          label: {
            color: '#333',
            fontWeight: 'bold',
            align: 'left',
            width: 80,
            overflow: 'none'
          }
        })
        // 小标签
        const rightLabel = t[1]
        datas.push({
          name: rightLabel,
          label: {
            color: rightLabel === this.checkedName ? '#347eee' : '#333',
            align: 'left',
            width: 80,
            overflow: 'truncate'
          },
          itemStyle: {
            color: '#779ABF',
            borderColor: '#779ABF'
          }
        })
      })
      // 2、name相同的去重
      datas = datas.filter((t, index) => {
        return datas.findIndex(s => s.name === t.name) === index
      })
      // 3、大标签按顺序设置颜色
      const colors = [
        '#5276D3',
        '#78D3C1',
        '#5AA0D3',
        '#83D6E3',
        '#72B0B1',
        '#5468AB',
        '#8B94E5',
        '#8B94E4',
        '#747AA8'
      ]
      let colorIndex = 0
      datas.forEach(t => {
        if (t.isBig) {
          t.itemStyle = {
            color: colors[colorIndex] || '#779ABF',
            borderColor: colors[colorIndex] || '#779ABF'
          }
          colorIndex += 1
        }
      })

      return datas
    },
    getLinks (list) {
      const links = []
      list.forEach(t => {
        links.push({
          source: t[0],
          target: t[1],
          value: 1,
          lineStyle: {}
        })
      })
      return links
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/index/components/BaseSankeyCharts.vue